import { Service } from "services/Service";
import { getToken, parseJWT as parseJWTFromAuth } from "services/Auth";
import ApiService from 'services/ApiService';
import { EMAIL_VALIDATION_REQUEST_SOURCE } from "commons/constants/emailValidation";

const USER_CERTIFICATE_ENDPOINT = '/api/v1/users/medal/certificate';

class ProfileService extends Service {
  async getUserBalance() {
    const data = await this.getWaiting(`/api/v1/users/profile`);
    return data.data.user.score;
  }

  parseJwt(token) {
    return parseJWTFromAuth(token);
  }

  static parseJWT(token) {
    return parseJWTFromAuth(token);
  }

  async getProfile() {
    const data = await this.getWaiting(`/api/v1/users/profile`);
    return data?.data;
  }

  async getUserProfileInfo() {
    const data = await this.getWaiting(`/api/v1/users/profile-info`);
    return data.data;
  }

  async getMedals() {
    const data = await this.getWaiting(`/api/v1/users/medal/counts`)
    return data.data;
  }

  async getMedalReceivements({ medalId }) {
    const data = await this.getWaiting(`/api/v1/users/medal/receivements/${medalId}`)
    return data.data;
  }

  async getMedalCertificate({ learnClassUserId }) {
    const data = await this.getWaiting(`/api/v1/users/medal/certificate/${learnClassUserId}`)
    return data.data[0].attributes;
  }

  async getNotifications() {
    const data = await this.getWaiting(`/api/v1/notifications`);
    return data?.data;
  }

  async getTermsOfUse() {
    const data = await this.getWaiting(`/api/v1/user/getTermsOfUse`)
    return data.data;
  }

  async insertBeetcoins(scoreObj) {
    return await this.put(`/api/v1/users/profile/score`, {
      interactionCode: scoreObj.interactionCode,
      postId: scoreObj.postId,
      description: scoreObj.description,
      detail: scoreObj.detail,
      target: scoreObj.target
    });
  }

  insertAcceptTermsOfUse() {
    const tokenJWT = this.parseJwt(getToken());
    return this.put(`/api/v1/user/acceptTermsOfUse`, {
      userId: tokenJWT.id
    });
  }

  async updateUser(data) {
    return await this.put(`/api/v1/user/profile`, data)
  }

  async getQuestions() {
    const res = await ApiService.get('/api/v1/users/mfa/multiple-questions')
    return res.data
  }

  async getAnswers() {
    const res = await ApiService.get('/api/v1/users/mfa/multiple-questions/answers')
    return res.data
  }

  async updateAnswers(data) {
    const res = await ApiService.post('/api/v1/users/mfa/multiple-questions/answers', data)
    return res.data
  }
  
  async checkCredentials(data) {
    const res = await ApiService.post('/api/v1/users/check-credentials', data)
    return res.data.data[0].attributes.message.isValid
  }

  getUserGroups(){
    const tokenJWT = this.parseJwt(getToken())
    return tokenJWT.groupsIds.split(',').map(Number)
  }

  async requestEmailValidation() {
    return await this.postWaiting('/api/v1/user/email-validation/request', {
      source: EMAIL_VALIDATION_REQUEST_SOURCE.MOBILE,
    });
  }

  async confirmEmailValidation(code) {
    return await this.postWaiting('/api/v1/user/email-validation', { code });
  }

  async signMedalCertificate(data) {
    const res = await this.postWaiting('/api/v1/users/medal/certificate/sign', data)
    return res
  }

  async renderCertificateImage(learnClassUserId, page = 'front', labels = {}) {
    const url = `${USER_CERTIFICATE_ENDPOINT}/${learnClassUserId}/render-image?page=${page}`;
    const response = await ApiService.post(url, labels, { responseType: 'blob' });
    return response.data;
  }

  async downloadCertificatePdf(learnClassUserId, labels = {}) {
    const url = `${USER_CERTIFICATE_ENDPOINT}/${learnClassUserId}/pdf`;
    const response = await ApiService.post(url, labels, { responseType: 'blob' });
    return response.data;
  }
}

const profileService = new ProfileService();

export { ProfileService, profileService };
export default ProfileService;
